// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRewritesTunnelPath"] = "/monitoring";globalThis["SENTRY_RELEASE"] = {"id":"Ew1LEgbEkAkxmjVkajh4u"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import * as Sentry from "@sentry/nextjs";
import {DEBUG} from "./config";

const API_MODULES = new Set([
  "account", "campagne", "forms", "forms_submit", "galeries", "links",
  "organisations", "paiement", "travel", "v1",
]);

function safeApiModule(error) {
  const raw = error?.config?.url;
  if (typeof raw !== "string") return null;
  try {
    const first = new URL(raw, "https://api.invalid").pathname.split("/").filter(Boolean)[0];
    return API_MODULES.has(first) ? `/${first}` : null;
  } catch (_) {
    return null;
  }
}

Sentry.init({
  enabled: !DEBUG,

  dsn: "https://cff68d4cbac702dbca6d431a5297fea5@o4506354224726016.ingest.us.sentry.io/4507181294288896",

  // Adjust this value in production, or use tracesSampler for greater control
  tracesSampleRate: 1,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,

  beforeSend(event, hint) {
    const message = event.exception?.values?.[0]?.value || event.message || "";
    // Ces ponts sont injectés par le navigateur ou une extension, absents du code web.
    if (/__firefox__|SCDynimacBridge|window\.webkit\.messageHandlers|window\.ethereum/i.test(message)) {
      return null;
    }
    if (/Network Error/i.test(message) && typeof navigator !== "undefined" && navigator.onLine === false) {
      return null;
    }

    // On garde le signal d'une API injoignable en ligne, mais on sépare les
    // incidents par module sans enregistrer d'URL contenant des données client.
    const original = hint.originalException;
    if (original?.isAxiosError) {
      const module = safeApiModule(original);
      if (module) {
        const status = String(original.response?.status || "network");
        event.tags = {...event.tags, "api.module": module, "api.status": status};
        event.fingerprint = ["axios-http", module, status];
      }
    }
    return event;
  },

  replaysOnErrorSampleRate: 1.0,

  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0.1,

  // You can remove this option if you're not planning to use the Sentry Session Replay feature:
  integrations: [
    Sentry.replayIntegration({
      // Additional Replay configuration goes in here, for example:
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],
});
